<template>
  <b-container>
    <b-card no-body class="mt-3">
      <b-tabs card v-model="tabIndex">
        <b-tab title="Choices">
          <div v-if="getChoices.length>0">
            <b-table responsive striped hover :items="getChoices" :fields="fields">
              <template v-slot:cell(#)="data">{{data.index + 1}}</template>
              <template v-slot:cell(choice)="data">{{data.item.choiceText}}</template>
            </b-table>
          </div>
        </b-tab>
      </b-tabs>
    </b-card>
  </b-container>
</template>

<script>
import { db } from "../../db";
export default {
  data() {
    return {
      tabIndex: 0,
      fields: [
        { key: "#", sortable: false },
        { key: "choice", sortable: false }
      ],

      choices: [],
      selectedQuestion: null,
      choiceText: "",
      updateOperation: false,
      questionId: ""
    };
  },

  computed: {
    // getChoices() {
    //   return this.$store.getters.getChoices;
    // },
    getChoices() {
      return this.$store.getters.getChoices;
    }
  },

  created() {
    if (this.$store.getters.getChoices.length == 0) {
      this.$store.dispatch("setQuestions");
    }
    if (this.$store.getters.getChoices.length == 0) {
      this.$store.dispatch("setChoices");
    }
  },
  methods: {
    setChoices(data) {
      console.log(data);
      this.choices = [];
      this.choices = this.getChoices.filter(el => {
        return el.questionId == data.id;
      });
    },
    addOrUpdateChoice() {
      if (
        this.choiceText.trim() !== "" &&
        this.selectedQuestion.questionText.trim() !== ""
      ) {
        if (!this.updateOperation) {
          db.collection("choices").add({
            choiceText: this.choiceText,
            questionId: this.selectedQuestion.id
          });
        } else {
          db.collection("choices")
            .doc(this.questionId)
            .update({
              choiceText: this.choiceText,
              questionId: this.selectedQuestion.id
            });
        }
        this.$store.dispatch("setChoices");
        this.resetValues();
      } else {
        alert("Please Enter Choice Text and Select a Question ");
      }
    },
    editQuestion(value) {
      this.tabIndex = 1;
      this.choiceText = value.choiceText;
      this.selectedQuestion = this.getModules.find(mod => {
        return mod.id == value.moduleId;
      });
      this.updateOperation = true;
      this.questionId = value.id;
    },
    deleteModule() {
      alert("Currently Deleting Choice is not working");
    },
    resetValues() {
      this.choiceText = "";
      this.selectedQuestion = null;
      this.tabIndex = 0;
      this.updateOperation = false;
    }
  }
};
</script>